import SettingsPage from './Settings'

export default function Settings() {
	return <SettingsPage />
}
